import styled from '@emotion/styled';

// Shared Modal Styles
export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #535862;
  
  &:hover {
    color: #181d27;
  }
`;

// Info Modal (Modal 1) Styles
export const InfoModalContent = styled.div`
  padding: 0;
    font-family: 'Inter',sans-serif;
  font-style: normal;
`;

export const InfoModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 0 24px;
`;

export const InfoModalIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 48px;
    height: 48px;
    color: #9dbc60;
  }
`;

export const InfoModalBody = styled.div`
  padding: 0 24px 24px 24px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const InfoModalSpesificText = styled.div`
  /* Heading */
  
  /* Text md/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  color: #717680;

`;
export const InfoModalText = styled.p`
  font-size: 14px;
  color: #535862;
  line-height: 20px;
  font-weight: 400;
  font-family: Inter, sans-serif;
  margin-bottom: 16px !important;
`;

export const InfoModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #181d27 !important;
  margin: 16px 0 4px 0;
`;

export const InfoModalList = styled.ul`
  margin: 12px 0;
  padding-left: 20px;

  li {
    font-size: 14px;
    color: #535862;
    line-height: 20px;

    strong {
      font-weight: 700;
      color: #535862;
    }
  }
`;

export const InfoModalLink = styled.a`
  color: #535862;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 400;
`;

export const InfoModalPrimaryLink = styled.a`
  color: #3f621a;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
`;

export const InfoModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #e9eaeb;
`;

export const InfoModalSecondaryButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  background: #ffffff;
  color: #181d27;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    background: #f9fafb;
  }
`;

export const InfoModalPrimaryButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: #9DBC60;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  border-width: 2px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background: #689f38;
  }
`;

// Detail Modal (Modal 2) Styles
export const DetailModalContent = styled.div`
  padding: 0;
`;

export const DetailModalHeader = styled.div`
  display: flex;
  z-index: -1;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
`;

export const DetailModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #181d27;
  line-height: 28px;
  margin: 0;
`;

export const DetailModalBody = styled.div`
  padding: 0px 24px 24px 24px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const DetailModalImageWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
  border-radius: var(--radius-xl, 12px);
  border: 1px solid #ebebeb;
  
  @media (max-width: 1400px) {
    flex-direction: column; /* Stacks items vertically */
    height: auto;
  }
  
`;

export const DetailModalImage = styled.div`
  width: 200px;
  min-width: 200px;
  height: 200px;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1400px) {
    width: 100%; /* Take full width of the card */
    min-width: 100%;
    height: 220px; /* Fixed height for the banner look */
    border-radius: 12px 12px 0 0; /* Round top corners only */
  }
  
`;

export const DetailModalImageContent = styled.div`
  flex: 1;
  position: relative;
  z-index: 9999;
  padding: 16px 24px 4px 24px;
`;

export const DetailModalPromoTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #181d27;
`;

export const DetailModalPrice = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
`;

export const DetailModalShortDesc = styled.div`
  font-size: 14px;
  color: #535862;
  line-height: 1.5;
  
  ul {
    margin: 8px 0;
    padding-left: 20px;
  }
  
  li {
    margin-bottom: 4px;
  }
`;

export const DetailModalSection = styled.div`
  margin-top: 24px;
`;

export const DetailModalSectionContent = styled.div`
  font-size: 14px;
  color: #181d27;
  line-height: 20px;

  p {
    margin-bottom: 4px !important;
    color: #535862 !important;
  }

  span {
    color: #535862 !important;
  }
  strong {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #181d27 !important;
  }

  ul {
    padding-left: 20px;
    color: #181d27 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  li {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #535862 !important;
  }

  a {
    color: #181d27;
    text-decoration: underline;
  }
`;

export const DetailModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #e9eaeb;
`;

export const DetailModalSecondaryButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  background: #ffffff;
  color: #181d27;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }
`;


export const DetailModalDeselectButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: #e53935; /* Seçimi kaldırma işlemi için kırmızı tonu */
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #d32f2f; /* Hover durumunda biraz daha koyu kırmızı */
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DetailModalPrimaryButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: #7cb342;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  border-width: 2px;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #689f38;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
